module.exports = __webpack_public_path__ + "static/media/pause_4000.cdfdc107.png";